export default __webpack_public_path__ + "content/340ea951af488cc6c422d79a01c7ff97.jpg";